// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Checkbox_inputWrapper__7iYsY","labelText":"Checkbox_labelText__+i-JV"};